import { BASE_URL } from 'config/urls';

import { callUrl, get } from 'utils/sdk';

export const fetchAssignmentsNamesList = () =>
  callUrl(get, `${BASE_URL}/v1/students/assignments/names/list/`);
